module.exports = __webpack_public_path__ + "img/Square.d8bdea3a.svg";